import React, { Component } from 'react';
import ReadAxios from "../axiosComponent/read";
import isEmpty from "lodash/isEmpty";
import { translate } from "react-i18next";
class BLNumbers extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          routeDetail: "",
        };
      }
    
      async componentDidMount() {
        let dataArray =
          (await ReadAxios({
              completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${this.props.data}/bl/list` 
            })) || [];
        dataArray = isEmpty(dataArray) ? "" : dataArray.data.data;
        this.setState({ routeDetail: dataArray || "" });
        console.log(dataArray);
      }
    render() {
        const { t } = this.props;
        const { routeDetail } = this.state;
        return (
          <>
                <span className="ml-3"> {t("list_view.bl_no") || "BL No."} :  </span>  <span className="ml-2"> {routeDetail.length != "" ? routeDetail : "NA"} </span>
        </>
        )
    }
}

export default translate("shipment")(BLNumbers);
